/*=========================================================================================
  File Name: moduleEmailState.js
  Description: Email Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

  trans: [],
  languages: [{
    title: 'English',
    iso: 'en'

  },
  {
    title: 'Russian',
    iso: 'ru'

  },
  {
    title: 'Armenian',
    iso: 'am'
  }]
}
